module.exports = __webpack_public_path__ + "img/objects-align-left.35645bb8.svg";